import { get, post, patch } from "../base.ehq.model";
import { serialize } from "./user-subscription.serializer";
import { deserialize } from "../base.serializer";

export const getUserSubscriptions = async (
  token: string,
  baseUrl: string,
  params = {}
) => {
  try {
    const queryPath = `${baseUrl}/user_subscriptions`;

    const res = await get(token, queryPath, params);
    const deserializeRes = await deserialize(res);

    return {
      meta: res.meta,
      subscriptions: deserializeRes
    };
  } catch (err) {
    throw new Error(err);
  }
};

export const subscribeProject = async (
  token: string,
  baseUrl: string,
  projectId: string,
  body = {}
) => {
  try {
    const queryPath = `${baseUrl}/projects/${projectId}/subscriptions`;

    const serializeBody = await serialize(body);
    const res = await post(token, queryPath, serializeBody);

    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};

export const unSubscribeProject = async (
  token: string,
  baseUrl: string,
  projectId: string,
  body = {}
) => {
  try {
    const queryPath = `${baseUrl}/projects/${projectId}/subscriptions/unsubscribe`;

    const res = await patch(token, queryPath, body);

    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
